import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import CustomSectionRecivingEnd from './RecivingEnd/CustomSectionRecivingEnd';
import { OrderDetails } from './OrderDetails';
import PurchaseOrderDetail from './PurchaseOrderDetail';
import SizeQuantityandPrices from './packUnits/SizeQuantityandPrices';
import { ShippingDetails } from './ShippingDetails';
import GrandTotalSection from './GrandTotalSection';
import { checkArray } from '../../../../Components/helper';
import CustomSection from './CustomSection';
import SupplierFactoryDetails from './SupplierFactoryDetails';
import CompanyDetails from './ComapyDetails';
import CompanyRecivingEnd from './RecivingEnd/CompanyRecivingEnd';
import FacortyRecivingEnd from './RecivingEnd/FactoryRecivingEnd';
import { usePOTemplateState } from '../P.O.TemplateContext/index';

function PODetails({ fromForm }) {
  const {
    duplicatingItem,
    deleteItem,
    editingInput,
    changeLabel,
    dropLocation,
    dropInLocation,
    deleteCard,
    modfiyReqAndEnable,
    forSwitch,
    poState,
    lengthEnabled,
  } = usePOTemplateState();

  const templateRendering = (item, i) => {
    switch (item?.key) {
      case 'A_F_Details':
        return (
          <Col lg={12}>
            {fromForm ? (
              <FacortyRecivingEnd
                element={item}
                eleIndex={i}
                dropLocation={dropLocation}
                dropInLocation={dropInLocation}
                fromForm={fromForm}
                modfiyReqAndEnable={modfiyReqAndEnable}
                deleteCard={deleteCard}
                duplicatingItem={duplicatingItem}
                editingInput={editingInput}
                deleteItem={deleteItem}
                changeLabel={changeLabel}
                // onChange={onChange}
              />
            ) : (
              <SupplierFactoryDetails element={item} fromForm={fromForm} />
            )}
          </Col>
        );
      case 'Company_Details':
        return (
          <Col lg={12}>
            {fromForm ? (
              <CompanyRecivingEnd element={item} eleIndex={i} dropLocation={dropLocation} fromForm={fromForm} />
            ) : (
              <CompanyDetails element={item} fromForm={fromForm} />
            )}
          </Col>
        );
      case 'Ratio_Pack':
        return (
          <Col lg={12}>
            <SizeQuantityandPrices
              lengthEnabled={lengthEnabled}
              data={poState?.rigthColumn}
              index={i}
              dropLocation={dropLocation}
              forSwitch={forSwitch}
              fromForm={fromForm}
            />
          </Col>
        );
      case 'order_details':
        return (
          <Col lg={12}>
            <OrderDetails fromForm={fromForm} index={i} dropLocation={dropLocation} />
          </Col>
        );
      case 'Shipping_Details':
        return (
          <Col lg={12}>
            <ShippingDetails fromForm={fromForm} index={i} dropLocation={dropLocation} />
          </Col>
        );
      case 'Grand_Total':
        return (
          <Col lg={12}>
            <GrandTotalSection element={item} index={i} fromForm={fromForm} dropLocation={dropLocation} />
          </Col>
        );
      default:
        return (
          <Col lg={12}>
            {fromForm ? (
              <CustomSectionRecivingEnd
                element={item}
                eleIndex={i}
                dropLocation={dropLocation}
                dropInLocation={dropInLocation}
                fromForm={fromForm}
                modfiyReqAndEnable={modfiyReqAndEnable}
                deleteCard={deleteCard}
                duplicatingItem={duplicatingItem}
                editingInput={editingInput}
                deleteItem={deleteItem}
                changeLabel={changeLabel}
              />
            ) : (
              <CustomSection element={item} fromForm={fromForm} />
            )}
          </Col>
        );
    }
  };

  return (
    <Container fluid>
      {!fromForm && <PurchaseOrderDetail data={poState?.rigthColumn} index={0} fromForm={fromForm} />}
      {poState?.rigthColumn?.templateJsonSchema?.filter((e) => e?.key === 'order_details')?.length === 0 && (
        <OrderDetails fromForm={fromForm} index={1} dropLocation={dropLocation} />
      )}
      <div>
        {checkArray(poState?.rigthColumn?.templateJsonSchema) &&
          poState?.rigthColumn?.templateJsonSchema?.map((item, i) => {
            return <Row key={`${item?.id}`}>{templateRendering(item, i)}</Row>;
          })}
      </div>
    </Container>
  );
}

export default PODetails;
